import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { DossierItemType } from "dto/Dossier/DossierItemType";
import Popper from "components/Popper";
import { ITag } from "dto/ITag";
import classNames from "classnames";
import TagBadge from "components/TagBadge";
import tagsService from "api/tagsService";
import ChooseTagNew from "components/ChooseTagNew";
import { Tooltip } from "@mui/material";
import PackagesContext from "contexts/PackagesContext";
import { useTranslation } from "react-i18next";

const TagCell: FC<Props> = ({ element, tags }) => {
  const { t } = useTranslation();
  const refTag = useRef(null);
  const { packages, setPackages } = useContext(PackagesContext);
  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage();
  const [showTagsSmall, setShowTagsSmall] = useState(false);

  const [findedTags, setFindedTags] = useState<ITag[]>([]);

  useEffect(() => {
    const t = tags?.filter((tag) =>
      element?.TagIds?.find((iTag) => tag.Id === iTag)
    );

    setFindedTags(t);
  }, [element?.TagIds, tags]);

  const handleUpdateTags = (tags: ITag[]) => {
    const newPackages = [...packages];

    const el = newPackages.find(
      (c) => c.Id === element.Id && c.Kind === element.Kind
    );

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    setPackages(newPackages);
  };

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        Items: [{ Id: element.Id, Kind: element.Kind }],
        TagId: tag.Id,
      },
      {
        onSuccess: () => {
          setFindedTags(findedTags.filter((ftag) => ftag.Id !== tag.Id));
        },
      }
    );
  };

  if (element.Type === DossierItemType.Folder) {
    return <></>;
  }

  return (
    <div
      className={classNames(
        styles.tags,
        findedTags && findedTags.length > 0 ? styles.notEmpty : styles.empty
      )}
      ref={refTag}
    >
      {findedTags.map((tag) => (
        <div onClick={() => setShowTagsSmall(!showTagsSmall)}>
          <TagBadge
            onRemove={(tag) => handleRemoveTag(tag)}
            tag={tag}
            key={`tag_${element.Id}_${tag.Id}`}
          />
        </div>
      ))}

      {findedTags &&
        findedTags.length === 0 &&
        element.Type !== DossierItemType.Link && (
          <Tooltip title={t("tooltips.setTag")}>
            <div>
              <div
                className={styles.fakeBadge}
                onClick={(e) => {
                  setShowTagsSmall(!showTagsSmall);
                  e.stopPropagation();
                }}
              >
                ...
              </div>
            </div>
          </Tooltip>
        )}

      {showTagsSmall && (
        <Popper
          anchorEl={refTag?.current}
          open={showTagsSmall}
          setOpen={setShowTagsSmall}
        >
          <ChooseTagNew
            toggle={setShowTagsSmall}
            updateTags={handleUpdateTags}
            //@ts-ignore
            toTag={element as IPackage}
          />
        </Popper>
      )}
    </div>
  );
};

export default TagCell;
